import { render, staticRenderFns } from "./categoryCar.vue?vue&type=template&id=3998d781&"
import script from "./categoryCar.vue?vue&type=script&lang=js&"
export * from "./categoryCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports